import { useContext, useMemo } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconAngleRight } from '@iwoca/icons';
import { Link } from 'react-router';

import { buildQueryString } from '../../../../utils/queryParams';
import { useCurrentOfferId } from '../../../hooks/useCurrentOfferId';
import { SecurityCheckListStep } from '../../../hooks/useNonLinearSecurityChecks.hook';
import { RouteContext } from '../../../routes';

interface SecurityChecksListStepProps {
  step: SecurityCheckListStep;
  stepName: string;
}

export const SecurityChecksListStep = ({
  step,
  stepName,
}: SecurityChecksListStepProps) => {
  const queryString = buildQueryString();
  const { basePath } = useContext(RouteContext);
  const offerId = useCurrentOfferId();

  const stepUrl = useMemo(
    () => `${basePath}/${stepName}/${queryString}`,
    [basePath, stepName, queryString],
  );

  const completeSecurityChecks = (isEditing = false) => {
    tracking.ampli.nonLinearSecurityStepVisited({
      offer_id: offerId!,
      step_name: stepName,
      is_editing: isEditing,
    });
    return true;
  };

  return (
    <div
      className="flex w-full items-center justify-between gap-xs p-xl hover:bg-primary-97"
      data-testid={stepName}
    >
      <div className="flex flex-col gap-y-s">
        {step.completed ? (
          <p className="m-0 text-l font-med text-primary-10">
            {step.completedTitle}
          </p>
        ) : (
          <Link
            to={stepUrl}
            onClick={() => completeSecurityChecks()}
            className="m-0 flex items-center gap-s text-l font-med text-primary-40 no-underline hover:cursor-pointer"
          >
            {step.title}
            <IconAngleRight className="size-l" />
          </Link>
        )}
        {step.completed && step.subTitle}
        {step.editable && step.completed && (
          <Link
            to={stepUrl}
            onClick={() => completeSecurityChecks(true)}
            className="flex h-2xl w-fit items-center gap-xs text-s font-bold text-primary-40 no-underline hover:cursor-pointer hover:underline"
          >
            <p className="m-0">Edit</p>
            <IconAngleRight />
          </Link>
        )}
      </div>
      {step.completed && (
        <div className="flex h-[20px] w-[88px] items-center rounded-l bg-success-lt">
          <p className="px-s text-s font-med text-success-drk">Completed</p>
        </div>
      )}
    </div>
  );
};
